export const APP_CONSTANTS = {
  SET_RUNNING: 'APP__SET_RUNNING',
  CHANGE_OPTION: 'APP__CHANGE_OPTION',
  CHANGE_SPEED: 'APP__CHANGE_SPEED',
  CLEAR_FIELD: 'APP__CLEAR_FIELD',
  SET_CUSTOM_FIELD: 'APP__SET_CUSTOM_FIELD',
};
